<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header">{{
      $t("llm_config.client_description.title")
    }}</v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="6">
              <v-select
                v-model="is_use_custom_system_prompt"
                :items="[
                  {
                    text: $t('llm_config.client_description.custom_prompt_yes'),
                    value: true,
                  },
                  {
                    text: $t('llm_config.client_description.custom_prompt_no'),
                    value: false,
                  },
                ]"
                :label="
                  $t('llm_config.client_description.use_custom_system_prompt')
                "
                :rules="form_roles.booleanField"
                outlined
                required
                light
                :menu-props="{ bottom: true, offsetY: true }"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row
            justify="center"
            aligne="center"
            v-if="!is_use_custom_system_prompt"
          >
            <v-col cols="12" md="6">
              <v-textarea
                v-model="description"
                :label="
                  $t('llm_config.client_description.client_description_label')
                "
                :rules="form_roles.text"
                rows="4"
                :placeholder="
                  $t(
                    'llm_config.client_description.client_description_placeholder'
                  )
                "
                variant="filled"
                outlined
                required
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="contact"
                :label="
                  $t('llm_config.client_description.client_contact_label')
                "
                :rules="form_roles.text"
                rows="4"
                :placeholder="
                  $t('llm_config.client_description.client_contact_placeholder')
                "
                variant="filled"
                outlined
                required
                :hint="
                  $t(
                    'llm_config.client_description.the_parameters_used_to_write_the_contact'
                  )
                "
                persistent-hint
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="name"
                :label="$t('llm_config.client_description.client_name_label')"
                :rules="form_roles.text"
                rows="4"
                :placeholder="
                  $t('llm_config.client_description.client_name_placeholder')
                "
                variant="filled"
                outlined
                required
                :hint="
                  $t(
                    'llm_config.client_description.this_parameters_only_for_brands'
                  )
                "
                persistent-hint
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="no_answer"
                :label="
                  $t('llm_config.client_description.client_no_answer_label')
                "
                :rules="form_roles.optionalField"
                rows="4"
                :placeholder="
                  $t(
                    'llm_config.client_description.client_no_answer_placeholder'
                  )
                "
                variant="filled"
                outlined
                required
                :hint="
                  $t(
                    'llm_config.client_description.this_parameters_contains_the_text_instruction'
                  )
                "
                persistent-hint
              >
              </v-textarea>
            </v-col>
            <v-col cols="12">
              <v-card outlined class="ma-2">
                <v-card-title>{{
                  $t("llm_config.client_description.prompts_informations")
                }}</v-card-title>
                <v-card-text>
                  <v-row dense no-gutters justify="center" align="center">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="newItem1"
                        outlined
                        clearable
                        dense
                        color="cleed_blue"
                        :append-icon="
                          newItem1 && newItem1.length ? 'mdi-check-bold' : ''
                        "
                        @click:append="addNewItem('informations')"
                        @keydown.enter="addNewItem('informations')"
                      />
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row
                        v-if="!informations.length"
                        dense
                        no-gutters
                        justify="center"
                      >
                        <v-col cols="12">
                          <span class="grey--text">{{
                            $t("llm_config.client_description.no_informations")
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row dense no-gutters justify="start" align="center">
                        <v-col
                          v-if="informations.length"
                          cols="12"
                          class="text-caption"
                        >
                          <v-icon small class="mb-1"> mdi-information </v-icon>
                          {{
                            $t(
                              "llm_config.client_description.click_on_the_information_to_copy"
                            )
                          }}
                        </v-col>
                        <v-col
                          cols="auto"
                          v-for="(item, i) in informations"
                          :key="i"
                        >
                          <v-chip
                            close
                            large
                            label
                            class="ma-1 pa-1 px-3 text-wrap font-weight-medium"
                            @click:close="removeItem('informations', i)"
                            outlined
                            @click="copyText(item)"
                          >
                            {{ item }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card outlined class="ma-2">
                <v-card-title>{{
                  $t(
                    "llm_config.client_description.prompts_instructions_behaviour"
                  )
                }}</v-card-title>
                <v-card-text>
                  <v-row dense no-gutters justify="center" align="center">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="newItem2"
                        outlined
                        clearable
                        dense
                        color="cleed_blue"
                        :append-icon="
                          newItem2 && newItem2.length ? 'mdi-check-bold' : ''
                        "
                        @click:append="addNewItem('instructions')"
                        @keydown.enter="addNewItem('instructions')"
                      />
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row
                        v-if="!instructions.length"
                        dense
                        no-gutters
                        justify="center"
                      >
                        <v-col cols="12">
                          <span class="grey--text">{{
                            $t("llm_config.client_description.no_instructions")
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row dense no-gutters justify="start" align="center">
                        <v-col
                          v-if="instructions.length"
                          cols="12"
                          class="text-caption"
                        >
                          <v-icon small class="mb-1"> mdi-information </v-icon>
                          {{
                            $t(
                              "llm_config.client_description.click_on_the_prompt_to_copy"
                            )
                          }}
                        </v-col>
                        <v-col
                          cols="auto"
                          v-for="(item, i) in instructions"
                          :key="i"
                        >
                          <v-chip
                            close
                            large
                            label
                            class="ma-1 pa-1 px-3 text-wrap font-weight-medium"
                            @click:close="removeItem('instructions', i)"
                            outlined
                            @click="copyText(item)"
                          >
                            {{ item }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card outlined class="ma-2">
                <v-card-title>
                  {{
                    $t(
                      "llm_config.client_description.prompts_writing_tone_of_voice"
                    )
                  }}
                </v-card-title>
                <v-card-text>
                  <v-row dense no-gutters justify="center" align="center">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="newItem3"
                        outlined
                        clearable
                        dense
                        color="cleed_blue"
                        :append-icon="
                          newItem3 && newItem3.length ? 'mdi-check-bold' : ''
                        "
                        @click:append="addNewItem('writting')"
                        @keydown.enter="addNewItem('writting')"
                      />
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row
                        v-if="!writting.length"
                        dense
                        no-gutters
                        justify="center"
                      >
                        <v-col cols="12">
                          <span class="grey--text">{{
                            $t("llm_config.client_description.no_writting")
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row dense no-gutters justify="start" align="center">
                        <v-col
                          v-if="writting.length"
                          cols="12"
                          class="text-caption"
                        >
                          <v-icon small class="mb-1"> mdi-information </v-icon>
                          {{
                            $t(
                              "llm_config.client_description.click_on_the_writting_to_copy"
                            )
                          }}
                        </v-col>
                        <v-col
                          cols="auto"
                          v-for="(item, i) in writting"
                          :key="i"
                        >
                          <v-chip
                            close
                            large
                            label
                            class="ma-1 pa-1 px-3 text-wrap font-weight-medium"
                            @click:close="removeItem('writting', i)"
                            outlined
                            @click="copyText(item)"
                          >
                            {{ item }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" v-else>
            <v-col cols="12" md="10">
              <v-textarea
                v-model="openaiConfig.langchain_settings.custom_system_prompt"
                label="(*) Custom System Prompt"
                :rules="form_roles.text"
                rows="4"
                placeholder="Prompt..."
                variant="filled"
                outlined
                required
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ClientDescription",
  data() {
    return {
      newItem1: "",
      newItem2: "",
      newItem3: "",
    };
  },
  props: {
    openaiConfig: Object,
    form_roles: Object,
  },
  created() {
    if (!this.openaiConfig?.langchain_settings?.client_description) {
      this.$set(this.openaiConfig.langchain_settings, "client_description", {});
    }
    if (!this.openaiConfig?.langchain_settings?.is_use_custom_system_prompt) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "is_use_custom_system_prompt",
        false
      );
    }
    if (!this.openaiConfig?.langchain_settings?.custom_system_prompt) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "custom_system_prompt",
        null
      );
    }
    if (
      !this.openaiConfig?.langchain_settings?.client_description?.informations
        ?.length
    ) {
      this.$set(
        this.openaiConfig.langchain_settings.client_description,
        "informations",
        []
      );
    }
    if (
      !this.openaiConfig?.langchain_settings?.client_description?.instructions
        ?.length
    ) {
      this.$set(
        this.openaiConfig.langchain_settings.client_description,
        "instructions",
        []
      );
    }
    if (
      !this.openaiConfig?.langchain_settings?.client_description?.writting
        ?.length
    ) {
      this.$set(
        this.openaiConfig.langchain_settings.client_description,
        "writting",
        []
      );
    }
    if (!this.openaiConfig?.langchain_settings?.client_description?.contact) {
      this.$set(
        this.openaiConfig.langchain_settings.client_description,
        "contact",
        null
      );
    }
    if (!this.openaiConfig?.langchain_settings?.client_description?.no_answer) {
      this.$set(
        this.openaiConfig.langchain_settings.client_description,
        "no_answer",
        null
      );
    }
  },
  computed: {
    is_use_custom_system_prompt: {
      get() {
        return (
          this.openaiConfig.langchain_settings.is_use_custom_system_prompt ||
          false
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_use_custom_system_prompt",
          value
        );
      },
    },
    custom_system_prompt: {
      get() {
        return (
          this.openaiConfig.langchain_settings.custom_system_prompt || null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "custom_system_prompt",
          value
        );
      },
    },
    description: {
      get() {
        return (
          this.openaiConfig.langchain_settings.client_description.description ||
          null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "description",
          value
        );
      },
    },
    contact: {
      get() {
        return (
          this.openaiConfig?.langchain_settings?.client_description?.contact ||
          null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "contact",
          value
        );
      },
    },
    name: {
      get() {
        return (
          this.openaiConfig?.langchain_settings?.client_description?.name ||
          null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "name",
          value
        );
      },
    },
    no_answer: {
      get() {
        return (
          this.openaiConfig?.langchain_settings?.client_description
            ?.no_answer || null
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "no_answer",
          value
        );
      },
    },
    informations: {
      get() {
        return (
          this.openaiConfig.langchain_settings.client_description
            .informations || []
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "informations",
          value
        );
      },
    },
    instructions: {
      get() {
        return (
          this.openaiConfig.langchain_settings.client_description
            .instructions || []
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "instructions",
          value
        );
      },
    },
    writting: {
      get() {
        return (
          this.openaiConfig.langchain_settings.client_description.writting || []
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.client_description,
          "writting",
          value
        );
      },
    },
  },
  methods: {
    addNewItem(type) {
      if (type === "informations") {
        const value = (this.newItem1 || "").trim();
        if (value && !this.informations.includes(value)) {
          this.informations = [...this.informations, value];
          this.newItem1 = "";
        }
      } else if (type === "instructions") {
        const value = (this.newItem2 || "").trim();
        if (value && !this.instructions.includes(value)) {
          this.instructions = [...this.instructions, value];
          this.newItem2 = "";
        }
      } else if (type === "writting") {
        const value = (this.newItem3 || "").trim();
        if (value && !this.writting.includes(value)) {
          this.writting = [...this.writting, value];
          this.newItem3 = "";
        }
      }
    },
    removeItem(type, index) {
      if (type === "informations") {
        const next = [...this.informations];
        next.splice(index, 1);
        this.informations = next;
      } else if (type === "instructions") {
        const next = [...this.instructions];
        next.splice(index, 1);
        this.instructions = next;
      } else if (type === "writting") {
        const next = [...this.writting];
        next.splice(index, 1);
        this.writting = next;
      }
    },
    copyText(text) {
      console.log("copy : ", text);
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(text).then((r) => {
          this.$store.dispatch("setSnackbar", {
            text: "Copy",
            color: "info",
            timeout: 800,
          });
        });
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", text);
      }
    },
  },
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce !important;
}
.v-chip {
  height: auto !important;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>
